import {
	ADMINALLOCATEDMODULE_SUCCESS,
	ADMINALLOCATEDMODULE_FAILED,
	RESET_ADMINALLOCATEDMODULE,
	LOADING_ADMINALLOCATEDMODULE,
	NETWORK_ERROR_ADMINALLOCATEDMODULE
} from "../types/index";

const initialState = {
	isLoading: false,
	success: false,
	network: false,
	failed: false,
	data: {}
};

export default (state = initialState, action) => {
	switch (action.type) {
		case LOADING_ADMINALLOCATEDMODULE:
			return {
				...state,
				isLoading: true,
				success: false,
				failed: false,
				network: false,
				data: {}
			};
		case ADMINALLOCATEDMODULE_FAILED:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: true,
				network: false,
				data: action.payload
			};
		case ADMINALLOCATEDMODULE_SUCCESS:
			return {
				...state,
				isLoading: false,
				success: true,
				failed: false,
				network: false,
				data: action.payload
			};
		case NETWORK_ERROR_ADMINALLOCATEDMODULE:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: false,
				network: true,
				data: {}
			};
		case RESET_ADMINALLOCATEDMODULE:
			return (state = initialState);
		default:
			return state;
	}
};
